import React from 'react';
import { Link } from 'react-router-dom';

const PRIMARY = '#3eb574';

const Footer: React.FC = () => {
  const cols: Array<{ title: string; links: [string, string][] }> = [
    { title: '产品', links: [['功能介绍', '/features'], ['价格方案', '/pricing'], ['客户案例', '/cases']] },
    { title: '支持', links: [['帮助中心', '/faq'], ['联系我们', '/faq']] },
    { title: '公司', links: [['关于我们', '/'], ['隐私政策', '/'], ['服务条款', '/']] },
  ];

  const platformIcons = [
    '/assets/images/logo/wx.png',
    '/assets/images/logo/alipay.png',
    '/assets/images/logo/titok.png',
    '/assets/images/logo/xhs.png',
  ];

  return (
    <footer style={{ background: '#0f172a', color: '#94a3b8', paddingTop: 64, paddingBottom: 40 }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 40, marginBottom: 48 }}>
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <img src="/assets/images/logo.jpg" style={{ width: 36, height: 36, borderRadius: 10 }} alt="佳达掌柜" />
              <span style={{ color: 'white', fontWeight: 700, fontSize: 16 }}>佳达掌柜</span>
            </div>
            <p style={{ fontSize: 14, lineHeight: 1.7, maxWidth: 200 }}>好用的店铺经营助手，助力1000+商家数字化经营。</p>
            <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
              {platformIcons.map((src, i) => (
                <div key={i} style={{ width: 32, height: 32, background: '#1e293b', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 6 }}>
                  <img src={src} style={{ width: '100%', height: '100%', objectFit: 'contain' }} alt="" />
                </div>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {cols.map(col => (
            <div key={col.title}>
              <div style={{ color: 'white', fontWeight: 600, fontSize: 14, marginBottom: 16 }}>{col.title}</div>
              {col.links.map(([label, href]) => (
                <div key={label} style={{ marginBottom: 10 }}>
                  <Link
                    to={href}
                    style={{ color: '#94a3b8', fontSize: 14, textDecoration: 'none', transition: 'color 0.15s' }}
                    onMouseEnter={e => (e.currentTarget.style.color = PRIMARY)}
                    onMouseLeave={e => (e.currentTarget.style.color = '#94a3b8')}
                  >{label}</Link>
                </div>
              ))}
            </div>
          ))}

          {/* QR */}
          <div>
            <div style={{ color: 'white', fontWeight: 600, fontSize: 14, marginBottom: 16 }}>扫码体验</div>
            <img
              src="/assets/images/qrcode.jpg"
              style={{ width: 96, height: 96, borderRadius: 16, border: '3px solid #1e293b' }}
              alt="扫码体验"
            />
            <p style={{ fontSize: 12, marginTop: 10 }}>微信扫码，免费试用</p>
          </div>
        </div>

        <div style={{ borderTop: '1px solid #1e293b', paddingTop: 24, display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 12 }}>
          <span style={{ fontSize: 13 }}>© 2020–{new Date().getFullYear()} 上海天工明理信息技术有限公司 · 沪ICP备2024104469号-1</span>
          <span style={{ fontSize: 13 }}>隐私政策 · 服务条款</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
